import React from "react";
import OpenOrders from "../components/openorder";

const Orders = () => {
    return (
        <div>
            <OpenOrders />
        </div>
    );
};

export default Orders;
